import React from 'react';

export const SettingsPage: React.FC = () => {
    return (
        <div>
            <h1 className="text-2xl font-bold mb-4">Settings (LLM + prompts)</h1>
            <div className="bg-white dark:bg-content-dark rounded-xl border border-border-light dark:border-border-dark p-6 space-y-6 max-w-3xl">
                <section>
                    <h2 className="font-semibold mb-2">LLM provider</h2>
                    <p className="text-sm text-text-secondary-light dark:text-text-secondary-dark mb-2">
                        Phase 1.3: aktualnie default <code>openrouter</code> z modelem <code>anthropic/claude-haiku-4-5</code>.
                        Edycja providerów (groq/anthropic) i modeli — w bazie <code>llm_settings</code>.
                    </p>
                    <p className="text-xs text-text-secondary-light/70 dark:text-text-secondary-dark/70">
                        TODO Phase 1.5: full UI dla edit providers + per-channel prompts (table <code>channel_prompts</code>).
                    </p>
                </section>
                <section>
                    <h2 className="font-semibold mb-2">Channel prompts</h2>
                    <p className="text-sm text-text-secondary-light dark:text-text-secondary-dark">
                        Per channel (wa_cloud / messenger / ig_dm) system prompt. Default seed w migration 003.
                        Edytujesz w bazie SQLite (na VPS): <code>UPDATE channel_prompts SET system_prompt = '...' WHERE channel = 'wa_cloud';</code>
                    </p>
                </section>
                <section>
                    <h2 className="font-semibold mb-2">WhatsApp Cloud API</h2>
                    <p className="text-sm text-text-secondary-light dark:text-text-secondary-dark">
                        WABA: <code>665654256382554</code> · Phone: +48 791 581 239 · Phone ID: <code>636478392887426</code>
                    </p>
                </section>
            </div>
        </div>
    );
};
